/**
 * Unread applications, tracked per admin. The API gives, for the missions on
 * screen, when the admin last looked at their applications (`seenAtByMission`)
 * and a `baselineAt` for missions never opened, so that applications older
 * than the feature never count as unread.
 */

export const resolveMissionSeenAt = (views, idMission) => {
  if (!views || !idMission) return null;
  return views.seenAtByMission?.[String(idMission)] || views.baselineAt || null;
};

// Legacy applications carry no date: they are never flagged.
export const isApplicationUnread = (appliedAt, seenAt) =>
  Boolean(appliedAt && seenAt && new Date(appliedAt) > new Date(seenAt));

export const countUnreadApplications = (applications, seenAt) =>
  (applications || []).filter(
    (application) =>
      application.refused !== true && isApplicationUnread(application.createdAt, seenAt)
  ).length;
